module.exports = __webpack_public_path__ + "images/icons_v2/juul-pod-pack-single-green-9b624053.svg";